module.exports = "<embed src=\"./assets/pdf/Haus-und_Badeordnung.pdf\">\n"